/* eslint-disable import/prefer-default-export */
export const selectDetailsModalState = state => state.detailsModal;
